import type { ShellSlice } from '../bs/shell'

/**
 * Serbian overrides for the application frame.
 *
 * The jat reflex, mostly: *promijeni* → *promeni*, *svijetla* → *svetla*,
 * *sljedeće* → *sledeće*, *obavještenja* → *obaveštenja*, *dodijele* →
 * *dodele*, *ovdje* → *ovde*, *biće poslate* stays but *poslata* does not.
 *
 * The plural keys are absent: the three-form rule is the same and so is the
 * declension of *prijava*, so overriding them would repeat the base.
 */
export const shell: Partial<ShellSlice> = {
  'brand.illustrationAlt': 'Skeniranje QR nalepnice na opremi u pogonu',

  'language.change': 'Promeni jezik',

  'theme.light': 'Svetla tema',
  'theme.tooltip': '{current} · sledeće: {next}',

  'nav.tasks.hint': 'Zadaci dodeljeni vama',

  'boot.checkingSession': 'Provera sesije',

  'notifications.title': 'Obaveštenja',
  'notifications.empty': 'Nema obaveštenja',
  'notifications.emptyHint':
    'Ovde stižu zadaci koji vam se dodele i promene na vašim prijavama.',

  /*
   * `queue.offlineNotice` is deliberately absent. It is a long sentence with no
   * jat anywhere in it — "Prijave su sačuvane na uređaju i biće poslate…" is
   * already correct ekavica — so an override would be sixty words repeating the
   * base, and the test that forbids that is right to.
   */
  'queue.hint': 'Prijave se šalju automatski. Ovde možete proveriti šta je ostalo.',

  'module.disabled.description':
    '„{module}“ trenutno nije deo vaše aplikacije. Podaci su sačuvani — ako vam ovaj deo treba, obratite se svom administratoru.',
}
